import React, { Component } from 'react';
import DateFilter from './DateFilter';

class SingleBarSearch extends Component {
  constructor(props) {
    super(props);
    this.initQuery = this.props.activeSearchQ;
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleKeyDown = this.handleKeyDown.bind(this);
    this.handleClear = this.handleClear.bind(this);
    this.handleFilterOpen = this.handleFilterOpen.bind(this);
  }

  handleChange(event) {
    // Update query ONLY (no submit here)
    this.props.handleSearchChange(event.target.value);
  }

  handleKeyDown(event) {
    if (event.key === 'Enter') {
      event.preventDefault();
      this.props.handleSubmit();
    }
  }

  handleSubmit(event) {
    if (event) {
      event.preventDefault();
    }
    this.props.handleSubmit();
  }

  handleClear() {
    this.props.handleSearchChange('');
    setTimeout(() => {
      this.props.handleSubmit();
    }, 0);
  }

  handleFilterOpen() {
    const filterModal = document.querySelector('.search-results-app-filter');
    const scrim = document.querySelector('.filter-modal-overlay');

    // Store the trigger element so focus can be restored on close
    this._filterTrigger = document.activeElement;
    if (filterModal) {
      filterModal._previouslyFocusedElement = this._filterTrigger;
      filterModal.setAttribute('data-expanded', 'true');
      document.body.style.overflow = 'hidden';

      // Move focus into the dialog after the DOM updates
      requestAnimationFrame(() => {
        const closeBtn = filterModal.querySelector('.filter-modal-close-btn');
        if (closeBtn) {
          closeBtn.focus();
        }
      });
    }
    if (scrim) {
      scrim.setAttribute('aria-hidden', 'false');
    }
  }

  render() {
    const {
      initQvalue
    } = this.props;

    const placeholder = this.props.labels?.searchInputMessage || '';
    const appType = this.props.labels?.applicationName || '';


    return (
      <section className="sra-search filterpage">
        {this.props.showFilters && (
          <button
            className="filter-btn esri-ui-button esri-ui-button--medium esri-ui-button--brand"
            type="button"
            aria-label="Open filters"
            onClick={this.handleFilterOpen}
          >
            <span>{this.props.labels.filterLabel}</span>
          </button>
        )}

      <div className={`search-row ${appType === 'events' ? 'with-date' : ''}`} >
      <div className="single-bar-search">
            {/* Custom input replacing calcite-input */}
            <div className="single-bar-search-input">
              <input
                type="text"
                aria-label="Search"
                value={initQvalue}
                placeholder={placeholder}
                onChange={this.handleChange}
                onKeyDown={this.handleKeyDown}
              />

              {initQvalue && (
                <calcite-icon
                  class="search-input-clear"
                  icon="x"
                  scale="m"
                  aria-label="Clear input"
                  role="button"
                  tabIndex={0}
                  onMouseDown={(e) => {
                        e.preventDefault(); // stops blur for mouse interactions
                        this.handleClear();
                      }}
                  onKeyDown={(e) => {
                        if (e.key === 'Enter' || e.key === ' ') {
                          e.preventDefault();
                          this.handleClear();
                        }
                      }}>
                </calcite-icon>
              )}

              <span
                className={`search-icon-wrapper ${initQvalue ? 'search-active' : ''}`}
                role="button"
                tabIndex={0}
                aria-label="Search"
                onClick={this.handleSubmit}
                onKeyDown={(e) => {
                  if (e.key === 'Enter') {
                    this.handleSubmit(e);
                  }
                }}
              >
                <calcite-icon
                  class="search-icon"
                  icon="search"
                  scale="s"
                  aria-hidden="true">
                </calcite-icon>
              </span>

            </div>
          </div>

          {appType === 'events' && (
            <div className="date-wrapper">
            <DateFilter
              onDateChange={({ startDate, endDate, range }) => {
                if (this.props.onDateChange) {
                  this.props.onDateChange({ startDate, endDate, range });
                }
              }}
            />
            </div>
          )}
        </div>
      </section>
    );
  }
}

export default SingleBarSearch;
